// extracted by mini-css-extract-plugin
export default {"stickers":"Stickers_stickers__Ulz7o","sticker":"Stickers_sticker__eTmBR","stickerbg":"Stickers_stickerbg__bBRy+","stickerHover":"Stickers_stickerHover__XlLcO"};